/*********************************************************************************************************************************
 This class has been automatically generated using KLTT-APIRestGenerator project, don't do manual file modifications.
 Mon Oct 22 12:45:25 CEST 2018

 "Licensed to the Apache Software Foundation (ASF) under one or more contributor license agreements;
  and to You under the Apache License, Version 2.0. "
**********************************************************************************************************************************/

import {MyComplexObject} from './my-complex-object.model' ;

/**
 * No description for the module
 */
export class MyComplexObjectRef
{

    /**
	 * Public constructor
	 */
	constructor(public myComplexObject: MyComplexObject) { }
	
	/**
	 * @param myComplexObject the myComplexObject to set
	 */
	setMyComplexObject(myComplexObject)
	{
		this.myComplexObject = myComplexObject ;
	}
	
	/**
	 * @return the myComplexObject
	 */
	getMyComplexObject()
	{
		return this.myComplexObject ;
	}
		
	/**
	 * @return the object as string
	 */
	toString()
	{
		return JSON.stringify(this, null, 4) ;
	}
	
	/**
	 * @param pendingRecursiveCalls with the pending recursive calls
	 * @return a new instance of the class with a random values
	 */
	static generateRandomInstance(pendingRecursiveCalls: number)
	{
		if (pendingRecursiveCalls == 0)
		{
			return null ;
		}
		
		pendingRecursiveCalls -- ;
	
		var myComplexObject = MyComplexObject.generateRandomInstance(pendingRecursiveCalls) ;

		return new MyComplexObjectRef(myComplexObject) ;
	}
	
	/**
	 * @param pendingRecursiveCalls with the pending recursive calls
	 * @return a random array of this class
	 */		
	static generateRandomArrayInstance(pendingRecursiveCalls: number)
	{
		if (pendingRecursiveCalls == 0)
		{
			return null ;
		}
		
		pendingRecursiveCalls -- ;
	
		var randomArrayInstance = [] ;
		
		for(var i=0; i < 5; i++)
	   	{
	        randomArrayInstance[i] = MyComplexObjectRef.generateRandomInstance(pendingRecursiveCalls) ;
		}
		
		return randomArrayInstance ;
	}
	
	/**
	 * @param value with the json to be parsed
	 * @return an instance of this class
	 */	
	static parse(value)
	{
		var myComplexObject = MyComplexObject.parse(value.myComplexObject) ;

		return new MyComplexObjectRef(myComplexObject) ;	
	}
	
	/**
	 * @param value with the array of jsons to be parsed
	 * @return an array of instances of this class
	 */	
	static arrayParse(arrayValues)
	{
		var arrayInstances = [] ;
		
		var arrayValuesLength = arrayValues.length ;
		for(var i=0; i < arrayValuesLength; i++)
	   	{
	        arrayInstances[i] = MyComplexObjectRef.parse(arrayValues[i]) ;
		}
		
		return arrayInstances ;	
	}
};
